import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Row, Col, Button, Input, Modal, Table, message, Select } from "antd";
import List from "../../Components/Products/List";
import { withAppContext } from "../../store/contextStore";
import "./index.scss";
import AppConfigs from "../../Config/AppConfig";
import { Storage } from "aws-amplify";
import { list, deleteRecord, update } from "../../api/Apis";
import { CloseOutlined } from "@ant-design/icons";
import ErrorPage from "../ErrorPage";
import { CSVLink } from "react-csv";

const Search = Input.Search;
const { Option } = Select;
class Products extends Component {
  constructor(props) {
    super(props);
    this.state = {
      leadsData: [],
      filterData: [],
      productsData: [],
      csvProductsData: [],
      totalProductsData: [],
      priceData: [],
      productName: "",
      dataLoadingStatus: false,
      modalVisible: false,
      userDetails: JSON.parse(localStorage.getItem("userDetails")),
    };
  }

  componentDidMount() {
    this.setState({
      dataLoadingStatus: true,
    });
    this.getProducts();
  }
  getProducts = () => {
    list(AppConfigs["entityNames"]["products"]).then((result) => {
      if (result.success) {
        let productsData = result.data.sort((a, b) =>
          a["productName"] < b["productName"] ? -1 : 1
        );
        productsData = result.data.filter((item) => !item["linkId"]);
        let productLen = 0;
        productsData.map(async (product, index) => {
          productLen += 1;
          if (product?.["images"]?.[0]) {
            product["image"] = await Storage.get(product["images"][0]);
          }
          // assign the default image as part to "product["image"]" if there is no image
          if (!product["image"]) {
            const defaultImageKey = "pdf_logo.png"; // Use the same key you used to upload
            Storage.get(defaultImageKey).then((defaultImageUrl) => {
              product["image"] = defaultImageUrl;
            });
          }

          if (productsData.length === productLen) {
            this.setState({
              productsData: productsData,
              totalProductsData: productsData,
              dataLoadingStatus: false,
            });
            console.log("productsData", productsData);
          }
        });
        if (productsData.length === 0) {
          this.setState({
            dataLoadingStatus: false,
          });
        }
      } else {
        console.log(result.errors);
        this.setState({
          dataLoadingStatus: false,
        });
      }
    });
  };

  showModal = (data, row) => {
    let priceData = [];
    data.map((price) => {
      return priceData.push({
        key: price.size,
        size: price.size,
        // ton: price.ton?"$" + parseFloat(price.ton).toFixed(2):'N/A',
        pallet: price.pallet
          ? "$" + parseFloat(price.pallet).toFixed(2)
          : "N/A",
        // yard: price.yard?"$" + parseFloat(price.yard).toFixed(2):'N/A',
        supersack: price.supersack
          ? "$" + parseFloat(price.supersack).toFixed(2)
          : "N/A",
      });
    });
    this.setState({
      modalVisible: true,
      priceData: priceData,
      productName: row["productName"],
    });
  };

  searchData = (event) => {
    let searcingValue = event.target.value;
    let totalProductsData = [];
    if (searcingValue.length > 0) {
      searcingValue = searcingValue.toLowerCase();
      totalProductsData = this.state.totalProductsData.filter(
        (product) =>
          product.productCode.toLowerCase().indexOf(searcingValue) > -1 ||
          product.productName.toLowerCase().indexOf(searcingValue) > -1 ||
          product.description.indexOf(searcingValue) > -1
      );
    } else {
      totalProductsData = this.state.totalProductsData;
    }
    this.setState({
      productsData: totalProductsData,
    });
  };
  filterProduct = (event) => {
    let filterProduct = [];
    if (event.length > 0) {
      filterProduct = this.state.totalProductsData.filter(
        (product) => product.isActive.toString() === event
      );
    } else {
      filterProduct = this.state.totalProductsData;
    }
    this.setState({
      productsData: filterProduct,
    });
  };

  handleOk = (e) => {
    this.setState({
      modalVisible: false,
    });
  };

  handleCancel = (e) => {
    this.setState({
      modalVisible: false,
    });
  };

  transformSizesForCsv = (sizes) => {
    return sizes.map((size) => `'${size.size}'`);
  };

  transformProductsForCsv = (productsData) => {
    return productsData.map((product) => ({
      productCode: product.productCode,
      productName: product.productName,
      sizes: this.transformSizesForCsv(product.sizes).join(", "),
    }));
  };

  addProduct = () => {
    this.props.history.push("/app/products/addproduct");
  };

  deleteProduct = (id) => {
    this.setState({ dataLoadingStatus: true });
    deleteRecord(AppConfigs["entityNames"]["products"], id).then((result) => {
      if (result.success) {
        message.success("Product deleted successfully");
        this.getProducts();
      } else {
        console.log(result.errors);
      }
    });
  };

  changeStatus = (activeStatus, id) => {
    this.setState({
      dataLoadingStatus: true,
    });
    let data = {
      entityData: {
        isActive: activeStatus,
        linkId: null,
      },
    };
    let api = AppConfigs["entityNames"]["products"];
    update(api, id, data).then((result) => {
      if (result.success) {
        let disMsg = "Deactivate successfully";
        if (activeStatus) {
          disMsg = "Activate successfully";
        }
        message.success(disMsg);
        this.getProducts();
      } else {
        console.log(result.errors);
        message.error("Update failed");
        this.setState({
          dataLoadingStatus: false,
        });
      }
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    let productsData = [];
    if (sorter["order"] === "descend") {
      if (sorter["columnKey"] === "productCode") {
        productsData = this.state.productsData.sort((a, b) =>
          a["productCode"].toLowerCase() < b["productCode"].toLowerCase()
            ? 1
            : -1
        );
      } else if (sorter["columnKey"] === "productName") {
        productsData = this.state.productsData.sort((a, b) =>
          a["productName"].toLowerCase() < b["productName"].toLowerCase()
            ? 1
            : -1
        );
      } else if (sorter["columnKey"] === "description") {
        productsData = this.state.productsData.sort((a, b) =>
          a["description"].toLowerCase() < b["description"].toLowerCase()
            ? 1
            : -1
        );
      }
    } else if (sorter["order"] === "ascend") {
      if (sorter["columnKey"] === "productCode") {
        productsData = this.state.productsData.sort((a, b) =>
          a["productCode"].toLowerCase() > b["productCode"].toLowerCase()
            ? 1
            : -1
        );
      } else if (sorter["columnKey"] === "productName") {
        productsData = this.state.productsData.sort((a, b) =>
          a["productName"].toLowerCase() > b["productName"].toLowerCase()
            ? 1
            : -1
        );
      } else if (sorter["columnKey"] === "description") {
        productsData = this.state.productsData.sort((a, b) =>
          a["description"].toLowerCase() > b["description"].toLowerCase()
            ? 1
            : -1
        );
      }
    } else {
      productsData = this.state.productsData;
    }
    this.setState({
      productsData: productsData,
    });
  };
  render() {
    const priceColumns = [
      {
        title: "Size",
        dataIndex: "size",
        key: "size",
      },
      {
        title: "$/per Supersack",
        dataIndex: "supersack",
        key: "supersack",
      },
      {
        title: "$/per pallet",
        dataIndex: "pallet",
        key: "pallet",
      },
      // {
      //   title: "$/per yard",
      //   dataIndex: "yard",
      //   key: "yard",
      // },
    ];

    if (
      this.state.userDetails.userProfile !== "A" &&
      this.state.userDetails.userProfile !== "M"
    ) {
      return <ErrorPage />;
    }

    return (
      <div className="content-outer">
        <div className="content">
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              <h1 className="headings"> Products </h1>
            </Col>
            <Row style={{ margin: "10px" }}>
              <Col
                xs={24}
                sm={8}
                md={4}
                lg={4}
                style={{ marginTop: "1%", marginBottom: "5%" }}
              >
                <Search
                  className="products-search"
                  size="large"
                  placeholder="Search"
                  onChange={(event) => this.searchData(event)}
                />
              </Col>
              <Col
                xs={8}
                sm={8}
                md={3}
                lg={3}
                style={{ marginTop: "1%", marginLeft: "1%" }}
              >
                <div className="loads-select">
                  <Select
                    onChange={(event) => this.filterProduct(event)}
                    defaultValue="All"
                    notFoundContent={"Not found?!"}
                    style={{ width: 180 }}
                  >
                    <Option key="All" value="">
                      All
                    </Option>
                    <Option key="Active" value="true">
                      Active
                    </Option>
                    <Option key="Inactive" value="false">
                      Inactive
                    </Option>
                  </Select>
                </div>
              </Col>
              <Col xs={24} sm={8} md={16} lg={16} style={{ marginTop: "1%" }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={this.state.loading}
                  className="add-button"
                  onClick={() => this.addProduct()}
                  icon="plus"
                >
                  Add Product
                </Button>
              </Col>
            </Row>
          </Row>
          <Row>
            <Col
              lg={24}
              md={24}
              sm={24}
              xs={24}
              style={{ marginTop: "2%", overflowX: "auto" }}
            >
              <List
                data={this.state.productsData}
                dataLoadingStatus={this.state.dataLoadingStatus}
                modalData={(data, row) => this.showModal(data, row)}
                onTableChange={this.handleTableChange}
                deleteProduct={(id) => this.deleteProduct(id)}
                style={{ overflowX: "auto" }}
                changeStatus={(activeStatus, id) =>
                  this.changeStatus(activeStatus, id)
                }
                pagination={{ pagination: false }}
              />
            </Col>
            <Modal
              // title="Size & Price Details"
              visible={this.state.modalVisible}
              onOk={this.handleOk}
              onCancel={this.handleCancel}
              closable={true}
              footer={[
                <Button
                  key="submit"
                  className="cancel"
                  onClick={this.handleCancel}
                >
                  Close
                </Button>,
              ]}
            >
              <h1
                onClick={this.handleCancel}
                style={{ float: "right", cursor: "pointer" }}
              >
                <CloseOutlined />
              </h1>
              <div style={{ marginTop: "10%" }}>
                <h1 style={{ textAlign: "center" }}>Sizes & Prices Details</h1>
                <p style={{ textAlign: "center" }}>{this.state.productName}</p>
                <Table
                  columns={priceColumns}
                  style={{ overflowX: "auto" }}
                  dataSource={this.state.priceData}
                  pagination={false}
                />
              </div>
            </Modal>
            <Button>
              {/* NOT WORKING, cant find data */}
              <CSVLink
                data={this.transformProductsForCsv(this.state.productsData)}
                filename={"products.csv"}
              >
                Download CSV
              </CSVLink>
            </Button>
          </Row>
        </div>
      </div>
    );
  }
}

export default withAppContext(withRouter(Products));
